import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-confirmation-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatCheckboxModule, FormsModule],
  template: `
    <div class="dialog-container">
      <h2 class="title">{{data.header}}</h2>
      <p class="message">{{data.text}}</p>
      <div *ngIf="data.showCheckbox" style="text-align: left;">
        <mat-checkbox [(ngModel)]="isConfirmed" color="primary">
          {{data.checkboxText || 'confirm the action'}}
        </mat-checkbox>
      </div>
      <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="data.showCheckbox && !isConfirmed">Yes</button>
      <button mat-flat-button class="green-button"   *ngIf="data?.button != null" (click)="onSave()">{{data.button}}</button>
      <button mat-flat-button color="warn" (click)="onCancel()">No</button>
    </div>
  `,
  styles: [`
    .dialog-container {
      text-align: center;
      padding: 24px;
      min-width: 300px;
    }
    .title {
      font-size: 20px;
      margin-bottom: 10px;
      color: #d32f2f;
    }
    .message {
      font-size: 16px;
    }
    button {
      width: 100px;
      margin: 0 5px;
    }
  `]
})
export class ConfirmationDialogComponent {
  isConfirmed = false;

  constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,) { }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onSave() {
    this.dialogRef.close('save')
  }
}
